import script from "./CharacteristicsInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacteristicsInformation.vue?vue&type=script&setup=true&lang=js"

import "./CharacteristicsInformation.vue?vue&type=style&index=0&id=249b61ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-249b61ed"]])

export default __exports__